import type { ISEOProps } from "../types/core";

export const AdminTaxFormsPageSEO: ISEOProps = {
  title: "Admin Tax Forms - Sugar Cribs",
  description:
    "Manage tax forms and compliance documentation for creators on Sugar Cribs platform.",
};
